import showMessage from "$ACTIONS/messageUtil";
import { showResultPopup } from "$ACTIONS/helper";

/**
 * follow mapping table made by BA XY Lee, WW Yew
 * https://whimsical.com/f1-one-wallet-api-mapping-for-error-pop-up-window-H2CF738UijUA9JR7c3UyZJ
 */
// 通用 Promotion 錯誤彈窗處理函數
const showPromotionErrorModal = (errorCode, apiMessage, productGroupText = "", onClose = () => {}) => {
    // 定義錯誤類型 & 追蹤事件
    const errorMapping = [
        {
            codes: ["CP30001"], // 優惠審核中
            title: "ขอรับโปรโมชั่นสำเร็จ",
            content:
                "การขอรับโปรโมชั่นอยู่ระหว่างการตรวจสอบ\nสถานะจะได้รับการอัปเดตในไม่ช้า",
            trackEvent: {
                url: "promotion_application_in_process_popup",
                title: "Promotion Application In Process Popup",
            },
        },
        {
            codes: ["CP30003"], // 優惠已領取
            title: "โปรโมชั่นที่ขอรับ",
            content: "ขอรับโปรโมชั่นสำเร็จแล้ว\nสถานะจะได้รับการอัปเดตในไม่ช้า",
            trackEvent: {
                url: "bonus_claimed_popup",
                title: "Bonus Claimed Popup",
            },
        },
        {
            codes: [
                "BP00122",
                "CP30004",
                "CP30005",
                "CP30006",
                "CP30007",
                "CP30008",
                "CP30014",
                "CP30015",
            ], //優惠已過期 (已失效)
            title: "ขอรับโปรโมชั่นไม่สำเร็จ",
            content: "โปรโมชั่นหมดอายุแล้ว โปรดเลือกโปรโมชั่นอื่น",
            trackEvent: {
                url: "promotion_expired_popup",
                title: "Promotion Expired Popup",
            },
            onOkTrack: {
                category: "Promotion",
                action: "Promotion Expired",
                name: "Promotion_Expired_Popup_C_OK",
            },
        },
        {
            codes: ["CP30002"], // 已參加優惠 / 已申請優惠
            title: "ขอรับโปรโมชั่นสำเร็จ",
            content: "ขอรับโปรโมชั่นสำเร็จแล้ว สถานะจะได้รับการอัปเดตในไม่ช้า",
            trackEvent: {
                url: "promotion_applied_popup",
                title: "Promotion Applied Popup",
            },
        },
        {
            codes: ["BP00025"], // 無法申請 您还有彩金优惠还没完成流水需求，请在完成流水需求后再进行申请
            title: "ขอรับโปรโมชั่นไม่สำเร็จ",
            content:
                "คุณมีโปรโมชั่นที่ขอรับอยู่ก่อนหน้านี้\nและยังทำยอดหมุนเวียนไม่ครบกำหนด\nโปรดตรวจสอบเงื่อนไข ก่อนขอรับโบนัสถัดไป",
            trackEvent: {
                url: "promotion_application_rebate_not_enough_popup",
                title: "Promotion Application Rebate Not Enough Popup",
            },
            onOkTrack: {
                category: "Promotion",
                action: "Promotion Rebate Not Enough",
                name: "Promotion_Application_Popup_RebateNotEnough_C_OK",
            },
        },
        {
            codes: ["BP00005"], // 申请名额已满 此优惠名额已达上限，请选择其他彩金优惠
            title: "มีผู้สมัครเต็มแล้ว",
            content:
                "มีผู้สมัครโปรโมชั่นนี้เต็มแล้ว โปรดเลือกโปรโมชั่นโบนัสอื่น",
            trackEvent: {
                url: "promotion_application_full_popup",
                title: "Promotion Application Full Popup",
            },
            onOkTrack: {
                category: "Promotion",
                action: "Promotion Application Full",
                name: "Promotion_Application_Popup_Full_C_OK",
            },
        },
        {
            codes: ["BP00013"], //申请名额已满 申请表格已发送过或已达到最大申请次数
            title: "ขอรับโปรโมชั่นไม่สำเร็จ",
            content: "คุณได้ขอรับโปรโมชั่นนี้ไปแล้ว หรือมีผู้สมัครเต็มแล้ว",
            trackEvent: {
                url: "promotion_sent_or_personal_max_popup",
                title: "Promotion Sent or Hit Personal Max",
            },
        },
        {
            codes: ["CP30013", "BP00120"], // 尚有投注未结算，请稍候再尝试
            title: "การยกเลิกล้มเหลว", // 取消失敗
            content: "ยังมีบิลเดิมพันที่ยังไม่ได้รับการตัดสิน\nโปรดลองอีกครั้งในภายหลัง",
        },
    ];

    // 查找對應的錯誤類型
    const errorType = errorMapping.find((item) =>
        item.codes.includes(errorCode)
    );

    // 顯示彈窗
    if (errorType) {
        // **執行 Pushgtagpiwikurl**
        if (errorType?.trackEvent) {
            global.Pushgtagpiwikurl &&
                global.Pushgtagpiwikurl(
                    errorType.trackEvent.url,
                    errorType.trackEvent.title
                );
        }

        const content = productGroupText ? `${productGroupText} ${errorType?.content}` : apiMessage;

        showResultPopup({
            type: "info",
            title: errorType?.title || "",
            content: content || errorType?.content, // 如果 `API` 提供了 `message`，優先顯示
            okText: "ตกลง", // 我知道了
            onOk: () => {
                // **執行 piwik 追蹤事件**
                if (errorType?.onOkTrack) {
                    Pushgtagdata(
                        errorType.onOkTrack.category,
                        errorType.onOkTrack.action,
                        errorType.onOkTrack.name
                    );
                }

                // 執行傳入的 onClose
                onClose();
            },
        });
        return;
    } else {
        // 無匹配錯誤碼，顯示默認錯誤訊息
        showMessage("info", "โปรดลองอีกครั้งในภายหลัง", 80);
    }
};

export default showPromotionErrorModal;
